import React, {useContext} from 'react';
import QuoteContext from "../quote-context";

const Progress = () => {

	const {navigation, navigationDispatcher} = useContext(QuoteContext);

	const steps = [
		{ id: 'form', name: 'Blank Form', step: 'itinerary'},
		{ id: 'date', name: 'Date', step: 'itinerary' },
		{ id: 'itinerary', name: 'Itinerary', step: 'itinerary' },
		{ id: 'submit', name: 'Quote', step: 'summary' }
	];
	
	return (
		<div id="progress-bar">
			<ul className="quote-progress stag pd-r-dsk-xlrg mg-b-tch">
				
				<li className="destinations complete"><a href="/quote"><span className="quote-progress__name">City</span></a></li>
				
				{steps.map((item, index) => {
					
					if( index > 0 ) { //we don't show the form step
						
						const classList = [];

						if( index < navigation.progress ) {
							classList.push( 'complete' );
						}

						if( index == navigation.progress ) {
							classList.push( 'active' );
						}

						const style = index < navigation.progress ? { pointerEvents: 'all' } : { pointerEvents: 'none' } 

						return (
							<li key={`step-` + item.id} className={classList.join(' ')}>
								<a onClick={() => navigationDispatcher({type: "GOTO_STEP", step: item.step, params: null })}>
									<span className="quote-progress__name" style={style}>{item.name}</span>
								</a>
							</li>
						)
					}
				})}
			</ul>
		</div>
	)
}

export default Progress;
